module.exports = __webpack_public_path__ + "static/media/LS.9fc380a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LS.svg
// module id = 2198
// module chunks = 7